import Debug from 'debug'
import { createUpserter } from '@/app/shared/utils'
import { UpdateQuizSessionTrackingCommand, DeleteQuizSessionTrackingCommand } from '../api';
import { QuizSessionTrackingState,
         defaultQuizSessionTrackingState } from './quiz-session-tracking-state'

const debug = Debug('quiz-session-state-reducer')

type Collection = QuizSessionTrackingState[];
export type QuizSessionCommand = UpdateQuizSessionTrackingCommand | DeleteQuizSessionTrackingCommand;

const upsert = createUpserter<QuizSessionTrackingState, QuizSessionTrackingState> (
  (id) => defaultQuizSessionTrackingState(id));

export function quizSessionReducer(state: Collection, command: QuizSessionCommand) {
  switch (command.name) {
    case 'update-quiz-session': {
      
      const session = command.payload;
      debug('update-quiz-session', session.id, state)
      state = upsert(state, session.id, (item) => {
        const newState: QuizSessionTrackingState = {
          id: item.id,
          quizId: session.quizId,
          aspect: session.aspect,
          type: session.type,
          phase: session.phase,
          content: session.state
        }
        return newState
      })

      debug('update-quiz-session result', state)
      return state
    }
    case 'delete-quiz-session': {
      const sessionId = command.payload.id
      debug('delete-quiz-session', sessionId, state)

      const index = state.findIndex(x => x.id === sessionId)
      if (index >= 0) {
        const cloned = [ ...state ]
        cloned.splice(index, 1)
        state = cloned
      }

      debug('delete-quiz-session result', state)
      return state
    }
  }
}

